export default __webpack_public_path__ + "static/SRI 1100 - Product Specifications & Technical Data-ec2512649d43aebec38519d40e6df785.pdf";